import React, {useEffect, useRef, useState} from "react";
import {Textfit} from 'react-textfit';
import {Button} from "react-bootstrap";
import ym from "react-yandex-metrika";
import {useAppSelector} from "../../../../store/hooks";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {SWAL_ALERT_DEFAULTS} from "../../../../Utils/defaults";
import Upload from "./Upload";
import {MAX_SLIDES} from "../../../../Utils/maxSlides";

interface TextProps {
    initialText: string,
    isVisible: boolean,
    onAddText: (text: string) => void
}

const Text: React.FC<TextProps> = ({initialText, isVisible, onAddText}) => {

    const maxLength = 80;

    const makerData = useAppSelector(state => state.makerData)
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const [value, setValue] = useState<string>(initialText);
    const [inputText, setInputText] = useState<string>(initialText);
    const [fontSize, setFontSize] = useState<number>(80);
    const [isPlaceholderVisible, setPlaceholderVisible] = useState<boolean>(initialText.length == 0);
    const [charsLeft, setCharsLeft] = useState<number>(maxLength - initialText.length);

    useEffect(() => {
        if (isVisible) {
            textAreaRef.current?.focus();
            // https://github.com/malte-wessel/react-textfit/issues/82
            window.dispatchEvent(new CustomEvent('resize'));
        }
    }, [isVisible]);

    // убираем все не алфавитные символы (смайлики и т.д.)
    const cleanString = (input: string) => {
        let cleanedValue = input.replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, '');
        cleanedValue = cleanedValue.substring(0, maxLength);
        return cleanedValue;
    }

    const onSubmitClick = () => {
        if (makerData.slides.length + 1 - 1 > MAX_SLIDES) {
            const MySwal = withReactContent(Swal)
            MySwal.close()
            MySwal.fire({
                ...SWAL_ALERT_DEFAULTS,
                title: '',
                text: 'В проект можно добавить не более ' + MAX_SLIDES + ' слайдов.',
                icon: 'info'
            });
            return;
        }

        var valueNoNL = value.replace(/\n+$/m, '');
        onAddText(valueNoNL);
        setValue('');
        setCharsLeft(maxLength);
    }

    return (
        <div className={'tab-text'}>
            <div className={'textarea-container'}>
                {
                    isVisible ?
                        <Textfit
                            mode="multi"
                            min={10}
                            max={80}
                            className={'textarea-fit-div'}
                            onReady={(divFontSize) => {
                                setFontSize(divFontSize);
                            }}
                        >
                            {inputText}
                        </Textfit> : ''
                }
                <textarea
                    maxLength={maxLength}
                    ref={textAreaRef}
                    onKeyDown={(e) => {
                        // Support Ctrl + Enter to submit form
                        if(e.key === 'Enter' && e.ctrlKey) {
                            onSubmitClick();
                        }
                    }}
                    onChange={(e) => {
                        const cleanedValue = cleanString(e.target.value);
                        setValue(cleanedValue)
                        setInputText(cleanedValue);
                        setPlaceholderVisible(cleanedValue.length == 0);
                        setCharsLeft(maxLength - cleanedValue.length);
                        if (Math.max(maxLength - cleanedValue.length, 0) == 0) {
                            ym('reachGoal', 'textSlideLimit');
                        }
                    }}
                    style={{fontSize: fontSize}}
                    value={value}
                >
                </textarea>
                {
                    isPlaceholderVisible ?
                        (
                            <div className={'placeholder'}>
                                <span>
                                    Напишите свой текст
                                </span>
                            </div>
                        ) : ''
                }
            </div>
            <Button className={'add-text-btn'}
                onClick={onSubmitClick}
                disabled={value.trim().length <= 0}>
                {
                    initialText.length == 0 ?
                        "Вставить текстовый слайд"
                        :
                        "Заменить текстовый слайд"
                }
            </Button>
            <div className={'max-length-indicator'}>
                Осталось символов: <b>{Math.max(charsLeft, 0)}</b>
                {
                    Math.max(charsLeft, 0) == 0 ?
                    (
                        <span>
                            <br/>
                            <b>Слишком много текста, его будет плохо видно на видео</b>
                        </span>
                    ) : ''
                }
            </div>
        </div>
    )
}

export default Text;